import { setResponsivesDataReducer } from "../reducers/responsives";
import ResponsivesEffect from "./../effects/responsivesEffect";

export const getResponsives = async (filter, ownResponsives) => {
  const resp = await ResponsivesEffect.getResponsives(filter, ownResponsives);
  return resp;
};
export const getPendingResponsives = async () => {
  const resp = await ResponsivesEffect.getPendingResponsives();
  return resp;
};
export const updateResponsive = async (responsive) => {
  const resp = await ResponsivesEffect.updateResponsive(responsive);
  return resp;
};
export const getResponsiveData = async (responsiveId) => {
  const resp = await ResponsivesEffect.getResponsiveData(responsiveId);
  return resp;
};
export const getResponsiveConfigData = async (dispatch) => {
  const resp = await ResponsivesEffect.getResponsiveConfigData();
  dispatch(setResponsivesDataReducer(resp));
  return resp;
};
